
window.API = {
    fetch: function(operation, params = {}) {
        const URL = `${site_url}ajax/functions.php`;
        
        const FORMDATA = new FormData();
        FORMDATA.append('operation', operation);
        
        Object.keys(params).forEach(key => {
            let value = params[key];
            if (value && typeof value === 'object') {
                value = JSON.stringify(value);
            }
            FORMDATA.append(key, value);
        });

        return fetch(URL, {
            method: "POST",
            body: FORMDATA
        })
        .then(function(response) {
            if (!response.ok) throw new Error('Network error');
            return response.json();
        })
        .catch(function(error) {
            console.error("API Error:", error);
            return null;
        });
    }
};
